// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/16e840bd/" + chunkId + "." + __webpack_require__.h() + ".v16e840bd.js";
};